module.exports = __webpack_public_path__ + "static/assets/e3c42f752e88598fb62dcc640bc93161.svg";